<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-3">
        <div class="btn-group my-1">
          <button
            type="button"
            class="btn btn-primary btn-outline btn-sm"
            v-bind:class="{ 'btn-simple': watchlistActive }"
            @click="watchlistActive = false"
          >
            Recherche
          </button>
          <button
            type="button"
            class="btn btn-primary btn-outline btn-sm"
            v-bind:class="{ 'btn-simple': !watchlistActive }"
            @click="watchlistActive = true"
          >
            Watchlist
          </button>
        </div>
        <card>
          <div v-if="watchlistActive">
            <div v-if="conf.isPro" class="mb-2">
              <el-select
                class="select-primary select-sm"
                size="large"
                placeholder="Mes watchlist"
                v-model="currentWatchlist"
              >
                <el-option
                  v-for="(option, index) in watchlists"
                  class="select-primary"
                  :value="index"
                  :label="option.name"
                  :key="index"
                >
                </el-option>
              </el-select>
              <button
                type="button"
                class="btn btn-primary btn-outline px-3 ml-3 py-2"
                @click="createWatchlist()"
              >
                <i class="tim-icons icon-simple-add mr-1 align-middle"></i>
              </button>
            </div>
            <div
              v-if="
                conf.isPro &&
                  !filteredInstruments.length &&
                  currentWatchlist >= 0
              "
              class="text-center mt-3"
            >
              Commencez à ajouter des valeurs à votre watchlist à partir de la
              recherche.
            </div>
            <div v-if="!conf.isPro" class="text-center mt-4">
              Les watchlist sont disponibles pour les utilisateurs Pro.<br />
              <router-link class="pointer text-primary" tag="b" to="/pro">
                En savoir plus
              </router-link>
            </div>
          </div>
          <input
            type="text"
            v-model="search"
            class="form-control"
            placeholder="Name, Isin, symbol..."
            v-if="!watchlistActive"
            @focus="searchFocus = true"
            @blur="searchFocus = false"
          />
          <div v-if="searchFocus && search.length === 0">
            <div class="mt-2 text-primary">
              <small>
                Précédentes sélections :
              </small>
            </div>
          </div>
          <div
            v-bind:style="{ height: chartSize.height + 50 + 'px' }"
            style="overflow:auto"
          >
            <div
              v-for="(instrument, index) in filteredInstruments"
              :key="index"
              v-on:click="selectInstrument(instrument)"
              class="mt-2 d-flex"
              style="cursor: pointer"
            >
              <i
                v-if="conf.isPro"
                class="fa fa-star pointer mr-1"
                style="margin-top: 2px"
                v-on:click.stop="toggleWatchlist(instrument)"
                v-bind:class="{
                  'text-primary': flatWatchList.includes(instrument.isin)
                }"
              ></i>
              <quote
                :selected="currentInstrument === instrument"
                :name="instrument.na"
                :market="instrument.mk"
                :live="instrument.li"
              ></quote>
            </div>
            <div
              v-if="watchlistActive && currentWatchlist !== null"
              class="text-center mt-4"
              @click="deleteCurrentWatchlist()"
            >
              <span class="text-warning pointer">
                <small>Supprimer la liste</small>
              </span>
            </div>
          </div>
        </card>
      </div>
      <div class="col-xs-12 col-md-9">
        <div v-if="currentInstrument" class="row mb-4">
          <div class="col-12 col-md-6">
            <h2 class="my-0">
              {{ currentInstrument.na }}
              <el-tooltip
                :content="
                  $moment(currentInstrument.li.lt * 1000).format('llll')
                "
                effect="light"
                :open-delay="300"
                placement="top"
              >
                <span class="text-success ml-3">{{
                  currentInstrument.li.last
                    | currency({
                      symbol: $currency(mode),
                      fractionCount: currentInstrument.pd
                    })
                }}</span>
              </el-tooltip>
            </h2>
            {{ currentInstrument.isin }}
          </div>
          <div class="col-12 col-md-6 text-right" v-if="currentPosition">
            <div>
              <h1 class="my-0 d-inline-block align-middle">
                <i class="tim-icons icon-cart mr-1 align-middle"></i>
                {{
                  (currentPosition.quantity * currentInstrument.li.last)
                    | currency({
                      symbol: $currency(mode),
                      fractionCount: currentInstrument.pd
                    })
                }}
              </h1>
              <div
                class="ml-3 align-middle d-inline-block text-success"
                v-bind:class="{
                  'text-danger':
                    currentInstrument.li.last - currentPosition.value < 0
                }"
                style="line-height: 15px;"
              >
                {{
                  ((currentInstrument.li.last - currentPosition.value) *
                    currentPosition.quantity)
                    | currency({
                      symbol: $currency(mode),
                      fractionCount: currentInstrument.pd
                    })
                }}
                <br />
                {{
                  (((currentInstrument.li.last - currentPosition.value) /
                    currentPosition.value) *
                    100)
                    | currency({ symbol: "%" })
                }}
              </div>
            </div>
            Avec {{ currentPosition.quantity }} titres à
            {{
              currentPosition.value
                | currency({
                  symbol: $currency(mode),
                  fractionCount: currentInstrument.pd
                })
            }}
          </div>
        </div>
        <card v-if="currentInstrument">
          <div class="row text-center">
            <div class="col-6 col-md-3 mb-xs-3">
              <h6 class="my-0">
                {{
                  ((currentInstrument.in.av * currentInstrument.li.last) /
                    1000)
                    | currency({
                      symbol: "k" + $currency(mode),
                      fractionCount: 0
                    })
                }}
                / jours
              </h6>
              échangés en moyenne
            </div>
            <div class="col-6 col-md-3 mb-xs-3" v-if="currentInstrument.in.bk">
              <h6 class="my-0">
                {{ currentInstrument.in.p ? "Haussière" : "Baissière" }}
              </h6>
              à moyen terme
            </div>
            <div class="col-6 col-md-3 mb-xs-3" v-if="currentInstrument.in.bk">
              <h6 class="my-0">
                {{
                  currentInstrument.in.p
                    ? currentInstrument.in.st
                    : currentInstrument.in.bk
                      | currency({
                        symbol: $currency(mode),
                        fractionCount: currentInstrument.pd
                      })
                }}
              </h6>
              {{
                currentInstrument.in.p ? "Niveau de stop" : "Seuil de breakout"
              }}
            </div>
            <div class="col-6 col-md-6 pt-md-2" v-if="!currentInstrument.in.bk">
              Pas assez de recul pour déterminer la tendance...
              {{ currentInstrument.in.bk }}
            </div>
            <div class="col-6 col-md-3">
              <base-button type="primary" size="sm" @click="getIn = !getIn">
                {{ getIn ? "Fermer" : "Gérer ma position" }}
              </base-button>
            </div>
          </div>
        </card>
        <collapse-transition duration="200">
          <position
            v-show="getIn"
            v-if="currentInstrument"
            :instrument="currentInstrument"
          ></position>
        </collapse-transition>
        <div class="d-flex justify-content-between ">
          <div v-if="currentInstrument">
            <button
              type="button"
              class="btn btn-warning text-center btn-sm "
              @click="addNote()"
            >
              <i class="tim-icons icon-simple-add text-white"></i>
            </button>
            <button
              type="button"
              class="btn btn-warning btn-simple btn-sm "
              @click="displayNotes = !displayNotes"
            >
              {{ !displayNotes ? "Afficher les notes" : "Masquer les notes" }}
            </button>
          </div>
          <div
            class="text-right mb-2"
            v-if="currentInstrument && this.mode === 'pea'"
          >
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label
                class="btn btn-sm btn-warning btn-simple"
                @click="switchDisplay('GRAPH', false)"
                :class="{ active: currentDisplay === 'GRAPH' }"
              >
                Graphique
              </label>
              <label
                class="btn btn-sm btn-warning btn-simple"
                @click="switchDisplay('AMF', true)"
                :class="{ active: currentDisplay === 'AMF' }"
              >
                Déclarations AMF
              </label>
            </div>
          </div>
        </div>
        <card v-if="displayNotes && currentInstrument">
          <notes-table
            v-if="displayNotes && currentInstrument"
            :instrument="currentInstrument"
          ></notes-table>
        </card>
        <card v-if="currentDisplay === 'AMF'">
          <amf-table v-if="currentInstrument" :instrument="currentInstrument">
          </amf-table>
        </card>
        <card v-if="currentDisplay === 'GRAPH'">
          <div ref="chartWrapper">
            <h5 class="my-5 text-center" v-if="!currentInstrument">
              Sélectionner une valeur pour afficher le graph hebdo, ajouter la
              valeur à votre portefeuille, la supprimer, ...
            </h5>
            <div>
              <trading-graph
                v-if="currentInstrument"
                :instrument="currentInstrument"
                :use-conf="true"
              ></trading-graph>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Quote from "@/components/Quote";
import { mapGetters } from "vuex";
import {
  BaseSwitch,
  TabPane,
  Tabs,
  Collapse,
  CollapseItem,
  TradingGraph
} from "src/components";
import { CollapseTransition } from "vue2-transitions";
import Position from "./Instruments/Position";
import AmfTable from "./Instruments/AmfTable";
import NotesTable from "./Instruments/NotesTable";
import { Select, Option } from "element-ui";
import { addNote } from "../../dao/firestore";

export default {
  components: {
    NotesTable,
    Quote,
    TradingGraph,
    BaseSwitch,
    CollapseTransition,
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    Position,
    AmfTable,
    [Option.name]: Option,
    [Select.name]: Select
  },
  data() {
    return {
      displayNotes: false,
      searchFocus: false,
      watchlistActive: false,
      currentWatchlist: null,
      getIn: false,
      search: "",
      chartSize: {
        width: 200,
        height:
          window.innerWidth > 400
            ? window.innerHeight - 200
            : window.innerHeight / 3
      },
      currentDisplay: "GRAPH"
    };
  },
  computed: {
    flatWatchList() {
      return Array.prototype.concat(...this.watchlists.map(wl => wl.isin));
    },
    filteredInstruments() {
      if (this.watchlistActive) {
        if (this.currentWatchlist === null || this.currentWatchlist === -1)
          return [];

        return this.$store.getters["instruments/filterIsin"](
          this.watchlists[this.currentWatchlist].isin
        );
      }
      if (
        // previous search
        this.searchFocus &&
        this.search.length === 0 &&
        this.conf.search &&
        this.conf.search.length
      ) {
        return this.$store.getters["instruments/filterIsin"](this.conf.search);
      }
      return this.$store.getters["instruments/filterLivelist"](this.search);
    },
    currentPosition() {
      return this.$store.getters["auth/getPosition"](
        this.$store.getters["instruments/current"].isin
      );
    },
    ...mapGetters({
      currentInstrument: "instruments/current",
      conf: "auth/conf",
      mode: "auth/mode",
      watchlists: "auth/watchlists",
      user: "auth/user"
    })
  },
  methods: {
    selectInstrument: async function(instrument) {
      // Set current instrument
      this.$store.dispatch("instruments/select", instrument);
    },
    switchDisplay: function(tab, proTab) {
      this.currentDisplay = tab;
    },
    deleteCurrentWatchlist: function() {
      const wl = this.watchlists[this.currentWatchlist];
      this.$swal({
        title: "Attention !",
        text: `Vous êtes sur le point de supprimer la watchlist "${wl.name}". Cette action est irréversible.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-danger btn-fill",
        cancelButtonClass: "btn btn-danger btn-simple",
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("auth/deleteWatchlist", this.currentWatchlist);
          this.currentWatchlist = null;
        }
      });
    },
    addNote: async function() {
      this.$swal({
        input: "textarea",
        title: "Nouvelle note",
        text: "",
        inputPlaceholder: "",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Ajouter",
        cancelButtonText: "Ignorer",
        showCloseButton: true
      }).then(async result => {
        if (result.isConfirmed) {
          await addNote(this.user, {
            content: result.value,
            mode: this.mode,
            isin: this.currentInstrument.isin
          });
          this.$swal(
            "C'est fait !",
            "Votre note a été ajoutée avec succès.",
            "success"
          );
        }
      });
    },
    createWatchlist: async function() {
      this.$swal({
        input: "text",
        title: "Nouvelle watchlist",
        text: "Quel nom souhaitez-vous donner à votre watchlist ?",
        inputPlaceholder: "Valeurs tech, ToZeMoon, ...",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Confirmer",
        cancelButtonText: "Ignorer",
        showCloseButton: true
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("auth/addwatchlist", result.value);
        }
      });
    },
    toggleWatchlist: function(instrument) {
      // on supprime de toutes les watchlists
      if (this.flatWatchList.includes(instrument.isin)) {
        this.$store.dispatch("auth/removeFromWatchlist", instrument.isin);
      } else {
        if (this.watchlists.length === 0) {
          // Pas de watchlist, on en crée une par default
          this.$store.dispatch("auth/addwatchlist", "Favoris");
          // Une seule watchlist, on ajoute direct
        }

        if (this.watchlists.length === 1) {
          this.$store.dispatch("auth/addToWatchlist", {
            isin: instrument.isin,
            watchlistIndex: 0
          });
        }
        // Sinon on propose !
        else {
          this.$swal({
            input: "select",
            inputOptions: this.watchlists.reduce(
              (a, v) => ({ ...a, [v.name]: v.name }),
              {}
            ),
            title: "Ajouter à une watchlist",
            text: `A quel watchlist souhaitez-vous ajouter ${instrument.na} ?`,
            inputPlaceholder: "Sélectionnez une watchlist",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Confirmer",
            cancelButtonText: "Ignorer",
            showCloseButton: true
          }).then(result => {
            if (result.isConfirmed) {
              this.$store.dispatch("auth/addToWatchlist", {
                isin: instrument.isin,
                watchlistIndex: this.watchlists.findIndex(
                  wl => wl.name === result.value
                )
              });
            }
          });
        }
      }
    }
  },
  mounted() {
    this.chartSize.width =
      this.$refs.chartWrapper.getBoundingClientRect().width - 5;
    if (this.watchlists.length > 0) {
      this.currentWatchlist = 0;
    }
  },
  beforeDestroy() {},
  metaInfo() {
    return {
      title: "Instruments Peamoni"
    };
  }
};
</script>
<style></style>
